const OBJECT_NAMES = {
    // Lshaped
    LEFT_WIDTH_WALL: 'leftWidthWall',
    LEFT_WIDTH2_WALL: 'leftWidth2Wall',
    RIGHT_WIDTH_WALL: 'rightWidthWall',
    RIGHT_WIDTH2_WALL: 'rightWidth2Wall',
    LEFT_DEPTH_WALL: 'leftDepthWall',
    RIGHT_DEPTH_WALL: 'rightDepthWall',

    // Rectangular walls
    BACK_WALL: 'backWall',
    FRONT_WALL: 'frontWall',
    LEFT_WALL: 'leftWall',
    RIGHT_WALL: 'rightWall',
};

export const TEXT_SPRITE_CONSTANT = 9;

export default OBJECT_NAMES;
